import { render, staticRenderFns } from "./MockTests.vue?vue&type=template&id=eec21180&scoped=true&"
import script from "./MockTests.vue?vue&type=script&lang=js&"
export * from "./MockTests.vue?vue&type=script&lang=js&"
import style0 from "./MockTests.vue?vue&type=style&index=0&id=eec21180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec21180",
  null
  
)

export default component.exports